import { TrustApiError } from '../errors';
import buildUrl, { decodeResponse, encodeRequest } from './utils';
var XHR_STATUS_DONE = 4;
function responseByStatus(status) {
    if (status >= 500) {
        return {
            status: 'error',
            description: 500 + ": Server error"
        };
    }
    if (status < 200 || (status >= 300 && status < 400)) {
        return {
            status: 'error',
            description: 'Unsupported status'
        };
    }
    return null;
}
function request(_a) {
    var method = _a.method, url = _a.url, body = _a.body, params = _a.params, _b = _a.contentType, contentType = _b === void 0 ? 'application/x-www-form-urlencoded' : _b, headers = _a.headers;
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, buildUrl(url, params), true);
        xhr.withCredentials = true;
        if (contentType) {
            xhr.setRequestHeader('Content-Type', contentType);
        }
        if (headers) {
            Object.keys(headers).forEach(function (header) {
                xhr.setRequestHeader(header, headers[header]);
            });
        }
        xhr.addEventListener('load', function () {
            if (xhr.readyState === XHR_STATUS_DONE) {
                var res = responseByStatus(xhr.status) || decodeResponse(xhr.responseText);
                return res.status === 'error'
                    ? reject(new TrustApiError(res.description))
                    : resolve(res);
            }
        });
        xhr.addEventListener('error', function () {
            reject(new TrustApiError('Invalid response'));
        });
        if (method === 'POST' && body) {
            xhr.send(encodeRequest(body));
        }
        else {
            xhr.send();
        }
    });
}
export default request;
